import { fetchUserPortfolioHistory } from '$lib/apis/portfolio';
import {
	loadingUserPortfolioPoints,
	userPortfolioChartRange,
	userPortfolioPoints
} from '$lib/portfolio/store';
import type { UserPortfolioPoint } from '$lib/types/user';
import { getPastTimestampInMillisecondsDeltaDaysOrMonths } from '$lib/util/util';
import { get } from 'svelte/store';

export async function getUserPortfolioValues() {
	if (get(loadingUserPortfolioPoints)) loadingUserPortfolioPoints.set(true);
	let endTimestamp: number = Date.now();
	let startTimestamp: number = getPastTimestampInMillisecondsDeltaDaysOrMonths(0, 5);
	if (get(userPortfolioChartRange) == '1W')
		startTimestamp = getPastTimestampInMillisecondsDeltaDaysOrMonths(7, 0);
	else if (get(userPortfolioChartRange) == '1M')
		startTimestamp = getPastTimestampInMillisecondsDeltaDaysOrMonths(0, 1);

	const data = await fetchUserPortfolioHistory(startTimestamp, endTimestamp);
	if (data) {
		const pointsData: Array<UserPortfolioPoint> = data.history;
		userPortfolioPoints.set(pointsData);
	}
	loadingUserPortfolioPoints.set(false);
}
